/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./ulist.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import UListOld from './ulistOld';
var listStyles = null;
var UListNew = function UListNew(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("ul", _extends({}, props, {
    className: ax(["_19bvv47k _bozgv47k"])
  }), children);
};
var UList = function UList(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(UListNew, props);
  }
  return /*#__PURE__*/React.createElement(UListOld, props);
};
export default UList;